import {Scene, WebXRDefaultExperience} from "@babylonjs/core";

export class DefaultScene {
    public static MainScene: Scene;
    public static DemoScene: Scene;
    public static XR: WebXRDefaultExperience;
}